import { JetView } from 'webix-jet';

/**
 * Class representing the details view for a withdrawal request.
 * @extends JetView
 */
export default class detailsWithdrawalRequestView extends JetView {
    /**
     * Configures the layout of the withdrawal request details view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size

        // Main information layout
        const main_info = {
            margin: 10,
            rows: [
                {
                    cols: [
                        {
                            rows: [
                                {
                                    view: 'text', // Input for ID
                                    name: 'Id',
                                    label: "<span class='icon-drivers-license-o'></span>" + _('Id'),
                                    labelPosition: 'top',
                                    placeholder: _('Id'),
                                    invalidMessage: _('A ID is required'), // Validation message
                                    disabled: true, // Disabled input
                                },
                                {
                                    view: 'text', // Input for Type
                                    name: 'Type',
                                    label: _('Tipo'),
                                    labelPosition: 'top',
                                    placeholder: _('Tipo'),
                                    disabled: true, // Disabled input
                                },
                                {
                                    view: 'text', // Input for Date
                                    name: 'Date',
                                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                                    labelPosition: 'top',
                                    placeholder: _('Fecha'),
                                    disabled: true, // Disabled input
                                },
                                {
                                    view: 'text', // Input for Amount
                                    name: 'Amount',
                                    label: _('Monto'),
                                    labelPosition: 'top',
                                    placeholder: _('Monto'),
                                    disabled: true, // Disabled input
                                    id: 'Monto', // ID for later reference
                                },
                            ],
                        },
                        {
                            rows: [
                                {
                                    view: 'textarea', // Input for Payment System Name
                                    name: 'PaymentSystemName',
                                    label: _('Nombre sistema de pago'),
                                    labelPosition: 'top',
                                    placeholder: _('Nombre sistema de pago'),
                                    disabled: true, // Disabled input
                                },
                                {
                                    id: 'buttonArrow', // Button for scrolling
                                    hidden: true, // Initially hidden
                                    width: 150,
                                    css: 'divButtonArrow',
                                    cols: [
                                        {},
                                        {
                                            view: 'button',
                                            value: "<span class='icon-arrow-up'></span>",
                                            css: 'buttonArrow',
                                            align: 'right',
                                            bottom: 20,
                                            right: 35,
                                            width: 50,
                                            height: 60,
                                            on: {
                                                onItemClick: function () {
                                                    // Scroll action
                                                    $$('a5').scrollTo(100, 0);
                                                },
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        // Left main layout configuration
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info],
        };

        // Upper section layout for larger screens
        const upper_section = {
            multiview: true,
            scroll: true,
            cols: [left_main, { gravity: 1, minWidth: 5 }],
        };

        // Upper section layout for narrow screens
        const upper_section_narrow = {
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            id: 'formDetails', // ID for the form
            rows: [screen !== 'small' ? upper_section : upper_section_narrow], // Conditional layout based on screen size
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        this.on(this.app, 'withdrawTransDetail:select', (person) => {
            // Event listener for selection
            form.setValues(person); // Set form values based on selected person
            this.$$('Monto').setValue(webix.i18n.priceFormat(person.Amount)); // Format and set amount
        });

        // Show button if screen width is less than 500
        webix.ready(function () {
            if (screen.width < 500) {
                $$('buttonArrow').show(); // Show the scroll button
            }
        });
    }
}

// FILE DOCUMENTED
